import { HighlightableContent } from '@aibees/shared/features';
import { Typography } from '@mui/material';
import { memo, useEffect, useState } from 'react';
import * as SX from './sx';
import type { LimitTypographyProps as Props } from './types';

export const LimitTypography = memo(
  ({
    wordLimit,
    value,
    withHighlight,
    sx,
    search,
    buttonSX: _buttonSX,
    ...props
  }: Props) => {
    const [showMore, setShowMore] = useState<boolean>(false);

    const toggleDescription = () => {
      setShowMore(!showMore);
    };

    const getDescriptionText = () => {
      const words = value.split(' ');
      if (showMore || wordLimit >= words.length) {
        return value;
      }
      const shortenedText = words.slice(0, wordLimit).join(' ');
      return `${shortenedText}...`;
    };

    useEffect(() => {
      if (search) setShowMore(true);
      else setShowMore(false);
    }, [search]);

    const descriptionText = getDescriptionText();

    return (
      <>
        {withHighlight ? (
          <HighlightableContent
            key={descriptionText}
            sx={sx}
            content={descriptionText}
            {...props}
          />
        ) : (
          <Typography key={descriptionText} component={'p'} {...props}>
            {descriptionText}{' '}
            {wordLimit < value.split(' ').length && (
              <Typography
                variant="body4"
                onClick={toggleDescription}
                color="primary.500"
                fontWeight={500}
                component="span"
                sx={SX.showMore}
              >
                {showMore ? 'Show Less' : 'Show More'}
              </Typography>
            )}
          </Typography>
        )}
      </>
    );
  }
);

LimitTypography.displayName = 'LimitTypography';
